<template>
    <section class="page-section" id="about">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Nosotros</h2>
                    <h3 class="section-subheading text-muted">Conoce nuestra trayectoria y compromiso.</h3>
                </div>
                <ul class="timeline">
                    <li>
                        <div class="timeline-image"><img class="rounded-circle img-fluid" 
                            loading="lazy"
                            src="@/assets/img/about/1.jpg" alt="Inicios" /></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>2009-2011</h4>
                                <h4 class="subheading">Nuestros Humildes Comienzos</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Fundamos el despacho con la visión de ofrecer asesoría legal accesible y de alta calidad, enfocándonos en construir relaciones de confianza con nuestros clientes desde el primer día.</p></div>
                        </div>
                    </li>
                    <li class="timeline-inverted">
                        <div class="timeline-image"><img class="rounded-circle img-fluid" 
                            loading="lazy"
                            src="@/assets/img/about/2.jpg" alt="Fundación" /></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading"> 
                                <h4>Marzo de 2011</h4>
                                <h4 class="subheading">Nace Barocio & Asociados</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Con la incorporación de nuevos talentos y la expansión de nuestras áreas de práctica, Barocio & Asociados se establece formalmente, consolidando nuestro compromiso con la excelencia legal.</p></div>
                        </div>
                    </li>
                    <li>
                        <div class="timeline-image"><img class="rounded-circle img-fluid" 
                            loading="lazy"
                            src="@/assets/img/about/3.jpg" alt="Nuevos Servicios" /></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading"> 
                                <h4>Diciembre 2015</h4>
                                <h4 class="subheading">Expansión de Servicios</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Ampliamos nuestra oferta de servicios para incluir derecho corporativo y laboral, respondiendo a las crecientes necesidades de nuestros clientes y del mercado.</p></div>
                        </div>
                    </li>
                    <li class="timeline-inverted">
                        <div class="timeline-image"><img class="rounded-circle img-fluid" 
                            loading="lazy"
                            src="@/assets/img/about/4.jpg" alt="Consolidación" /></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading"> 
                                <h4>Julio 2020</h4>
                                <h4 class="subheading">Consolidación y Crecimiento</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">A pesar de los desafíos globales, nuestro despacho experimentó un crecimiento significativo, fortaleciendo nuestra posición como líderes en el sector legal y ampliando nuestra cartera de clientes.</p></div>
                        </div>
                    </li>
                    <li class="timeline-inverted">
                        <div class="timeline-image">
                            <h4>
                                ¡Sé parte
                                <br />
                                de Nuestra
                                <br />
                                historia!
                            </h4>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
</template>